import {SUCCESS} from "../../../../constants/action-postfix";
import {GRADUATES_ORIENTATION_REQUEST} from "../graduatesOrientationReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GRADUATES_ORIENTATION_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};